/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiV1TrackTagsParams,
  GetApiV1TrackTagsTagIdUploadUrlParams,
  GetTrackTagPageResponse,
  GetTrackTagResponse,
  GetTrackTagRuleResponse,
  GetTrackTagUploadUrlResponse,
  GetTrackTagsResponse,
  PatchTrackTagRequestBody,
  PatchTrackTagResponse,
  PostTrackTagRequestBody,
  PostTrackTagResponse,
  ProblemDetails,
  PutApiV1TrackTagsTagIdRuleParams,
  TrackTagPopularCategory,
  TrackTagRule2,
  TrackTagRuleFilterResponse
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1TrackTags = (
    params: GetApiV1TrackTagsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackTagsResponse | null>(
      {url: `/api/v1/track-tags`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1TrackTagsQueryKey = (params?: GetApiV1TrackTagsParams,) => {
    return [
    `/api/v1/track-tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1TrackTagsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTags>>, TError = ProblemDetails | null>(params: GetApiV1TrackTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTags>>> = ({ signal }) => getApiV1TrackTags(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTags>>>
export type GetApiV1TrackTagsQueryError = ProblemDetails | null


export function useGetApiV1TrackTags<TData = Awaited<ReturnType<typeof getApiV1TrackTags>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackTagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTags>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTags<TData = Awaited<ReturnType<typeof getApiV1TrackTags>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTags>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTags>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTags<TData = Awaited<ReturnType<typeof getApiV1TrackTags>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTags<TData = Awaited<ReturnType<typeof getApiV1TrackTags>>, TError = ProblemDetails | null>(
 params: GetApiV1TrackTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTags>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1TrackTags = (
    postTrackTagRequestBodyNull: PostTrackTagRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PostTrackTagResponse | null>(
      {url: `/api/v1/track-tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTrackTagRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1TrackTagsMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackTags>>, TError,{data: PostTrackTagRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackTags>>, TError,{data: PostTrackTagRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1TrackTags'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1TrackTags>>, {data: PostTrackTagRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1TrackTags(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1TrackTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1TrackTags>>>
    export type PostApiV1TrackTagsMutationBody = PostTrackTagRequestBody | null
    export type PostApiV1TrackTagsMutationError = ProblemDetails | null

    export const usePostApiV1TrackTags = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1TrackTags>>, TError,{data: PostTrackTagRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1TrackTags>>,
        TError,
        {data: PostTrackTagRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1TrackTagsMutationOptions(options), queryClient);
    }
    export const getApiV1TrackTagsTagId = (
    tagId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackTagResponse | null>(
      {url: `/api/v1/track-tags/${tagId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackTagsTagIdQueryKey = (tagId: number,) => {
    return [
    `/api/v1/track-tags/${tagId}`
    ] as const;
    }


export const getGetApiV1TrackTagsTagIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError = ProblemDetails | null>(tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsTagIdQueryKey(tagId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>> = ({ signal }) => getApiV1TrackTagsTagId(tagId, signal);





   return  { queryKey, queryFn, enabled: tagId !== null && tagId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsTagIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>>
export type GetApiV1TrackTagsTagIdQueryError = ProblemDetails | null


export function useGetApiV1TrackTagsTagId<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError = ProblemDetails | null>(
 tagId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagId<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagId<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTagsTagId<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsTagIdQueryOptions(tagId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiV1TrackTagsTagId = (
    tagId: number,
    patchTrackTagRequestBodyNull: PatchTrackTagRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PatchTrackTagResponse | null>(
      {url: `/api/v1/track-tags/${tagId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTrackTagRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1TrackTagsTagIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>, TError,{tagId: number;data: PatchTrackTagRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>, TError,{tagId: number;data: PatchTrackTagRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1TrackTagsTagId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>, {tagId: number;data: PatchTrackTagRequestBody | null}> = (props) => {
          const {tagId,data} = props ?? {};

          return  patchApiV1TrackTagsTagId(tagId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1TrackTagsTagIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>>
    export type PatchApiV1TrackTagsTagIdMutationBody = PatchTrackTagRequestBody | null
    export type PatchApiV1TrackTagsTagIdMutationError = ProblemDetails | null

    export const usePatchApiV1TrackTagsTagId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>, TError,{tagId: number;data: PatchTrackTagRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1TrackTagsTagId>>,
        TError,
        {tagId: number;data: PatchTrackTagRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1TrackTagsTagIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1TrackTagsTagId = (
    tagId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/track-tags/${tagId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1TrackTagsTagIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>, TError,{tagId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>, TError,{tagId: number}, TContext> => {

const mutationKey = ['deleteApiV1TrackTagsTagId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>, {tagId: number}> = (props) => {
          const {tagId} = props ?? {};

          return  deleteApiV1TrackTagsTagId(tagId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1TrackTagsTagIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>>

    export type DeleteApiV1TrackTagsTagIdMutationError = ProblemDetails | null

    export const useDeleteApiV1TrackTagsTagId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>, TError,{tagId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1TrackTagsTagId>>,
        TError,
        {tagId: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1TrackTagsTagIdMutationOptions(options), queryClient);
    }
    export const getApiV1TrackTagsTagIdUploadUrl = (
    tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackTagUploadUrlResponse | null>(
      {url: `/api/v1/track-tags/${tagId}/upload-url`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1TrackTagsTagIdUploadUrlQueryKey = (tagId: number,
    params?: GetApiV1TrackTagsTagIdUploadUrlParams,) => {
    return [
    `/api/v1/track-tags/${tagId}/upload-url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1TrackTagsTagIdUploadUrlQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError = ProblemDetails | null>(tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsTagIdUploadUrlQueryKey(tagId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>> = ({ signal }) => getApiV1TrackTagsTagIdUploadUrl(tagId,params, signal);





   return  { queryKey, queryFn, enabled: tagId !== null && tagId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsTagIdUploadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>>
export type GetApiV1TrackTagsTagIdUploadUrlQueryError = ProblemDetails | null


export function useGetApiV1TrackTagsTagIdUploadUrl<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError = ProblemDetails | null>(
 tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagIdUploadUrl<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError = ProblemDetails | null>(
 tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagIdUploadUrl<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError = ProblemDetails | null>(
 tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTagsTagIdUploadUrl<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError = ProblemDetails | null>(
 tagId: number,
    params: GetApiV1TrackTagsTagIdUploadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdUploadUrl>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsTagIdUploadUrlQueryOptions(tagId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1TrackTagsTagIdRule = (
    tagId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackTagRuleResponse | null>(
      {url: `/api/v1/track-tags/${tagId}/rule`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackTagsTagIdRuleQueryKey = (tagId: number,) => {
    return [
    `/api/v1/track-tags/${tagId}/rule`
    ] as const;
    }


export const getGetApiV1TrackTagsTagIdRuleQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError = ProblemDetails | null>(tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsTagIdRuleQueryKey(tagId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>> = ({ signal }) => getApiV1TrackTagsTagIdRule(tagId, signal);





   return  { queryKey, queryFn, enabled: tagId !== null && tagId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsTagIdRuleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>>
export type GetApiV1TrackTagsTagIdRuleQueryError = ProblemDetails | null


export function useGetApiV1TrackTagsTagIdRule<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError = ProblemDetails | null>(
 tagId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagIdRule<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsTagIdRule<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTagsTagIdRule<TData = Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError = ProblemDetails | null>(
 tagId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsTagIdRule>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsTagIdRuleQueryOptions(tagId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiV1TrackTagsTagIdRule = (
    tagId: number,
    trackTagRule2Null: TrackTagRule2 | null,
    params?: PutApiV1TrackTagsTagIdRuleParams,
 signal?: AbortSignal
) => {


      return apiClient<TrackTagRuleFilterResponse | null>(
      {url: `/api/v1/track-tags/${tagId}/rule`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: trackTagRule2Null,
        params, signal
    },
      );
    }




export const getPutApiV1TrackTagsTagIdRuleMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>, TError,{tagId: number;data: TrackTagRule2 | null;params?: PutApiV1TrackTagsTagIdRuleParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>, TError,{tagId: number;data: TrackTagRule2 | null;params?: PutApiV1TrackTagsTagIdRuleParams}, TContext> => {

const mutationKey = ['putApiV1TrackTagsTagIdRule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>, {tagId: number;data: TrackTagRule2 | null;params?: PutApiV1TrackTagsTagIdRuleParams}> = (props) => {
          const {tagId,data,params} = props ?? {};

          return  putApiV1TrackTagsTagIdRule(tagId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1TrackTagsTagIdRuleMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>>
    export type PutApiV1TrackTagsTagIdRuleMutationBody = TrackTagRule2 | null
    export type PutApiV1TrackTagsTagIdRuleMutationError = ProblemDetails | null

    export const usePutApiV1TrackTagsTagIdRule = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>, TError,{tagId: number;data: TrackTagRule2 | null;params?: PutApiV1TrackTagsTagIdRuleParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1TrackTagsTagIdRule>>,
        TError,
        {tagId: number;data: TrackTagRule2 | null;params?: PutApiV1TrackTagsTagIdRuleParams},
        TContext
      > => {
      return useMutation(getPutApiV1TrackTagsTagIdRuleMutationOptions(options), queryClient);
    }
    export const getApiV1TrackTagsPageSlug = (
    slug: string | null,
 signal?: AbortSignal
) => {


      return apiClient<GetTrackTagPageResponse | null>(
      {url: `/api/v1/track-tags/page/${slug}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackTagsPageSlugQueryKey = (slug: string | null,) => {
    return [
    `/api/v1/track-tags/page/${slug}`
    ] as const;
    }


export const getGetApiV1TrackTagsPageSlugQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError = ProblemDetails | null>(slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsPageSlugQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>> = ({ signal }) => getApiV1TrackTagsPageSlug(slug, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsPageSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>>
export type GetApiV1TrackTagsPageSlugQueryError = ProblemDetails | null


export function useGetApiV1TrackTagsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTagsPageSlug<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError = ProblemDetails | null>(
 slug: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPageSlug>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsPageSlugQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1TrackTagsPopular = (

 signal?: AbortSignal
) => {


      return apiClient<(TrackTagPopularCategory | null)[] | null>(
      {url: `/api/v1/track-tags/popular`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1TrackTagsPopularQueryKey = () => {
    return [
    `/api/v1/track-tags/popular`
    ] as const;
    }


export const getGetApiV1TrackTagsPopularQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError = ProblemDetails | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1TrackTagsPopularQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>> = ({ signal }) => getApiV1TrackTagsPopular(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1TrackTagsPopularQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>>
export type GetApiV1TrackTagsPopularQueryError = ProblemDetails | null


export function useGetApiV1TrackTagsPopular<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError = ProblemDetails | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsPopular<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>,
          TError,
          Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1TrackTagsPopular<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1TrackTagsPopular<TData = Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1TrackTagsPopular>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1TrackTagsPopularQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






